(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fa-quick-add"] && !Shopify.designMode) return;
  try {
    /*
    Card swatches change the variant quick add adds (the theme's product form
    handles that); keep the button's accessible name in step with the colour.
  */
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
    const card = input.closest('product-card');
    const button = card?.querySelector('.fa-quick-add [ref="addToCartButton"]');
    if (!button || !input.closest('swatches-variant-picker-component')) return;
    button.setAttribute('aria-label', `Add ${button.dataset.faTitle}, ${input.value.replace(/-/g, ' ')} to cart`);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fa-swatch-switch"] && !Shopify.designMode) return;
  try {
    class FaSwatchSwitch extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.#onChange);

      const gallery = this.querySelector('[data-fa-hover-gallery]');
      gallery?.addEventListener('pointerenter', this.#onHoverStart);
      gallery?.addEventListener('pointerleave', this.#onHoverEnd);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.#onChange);
    }

    /** Desktop hover: show the finish's second photo, loading it on first use. */
    #onHoverStart = (event) => {
      if (event.pointerType !== 'mouse') return;
      const gallery = event.currentTarget;
      const image = gallery.querySelector('[data-fa-hover-image]');
      if (!(image instanceof HTMLImageElement) || !image.dataset.src) return;
      gallery.setAttribute('data-fa-hovering', '');
      if (image.getAttribute('src') !== image.dataset.src) this.#loadHover(image);
    };

    #onHoverEnd = (event) => {
      if (event.pointerType !== 'mouse') return;
      event.currentTarget.removeAttribute('data-fa-hovering');
    };

    /** @param {HTMLImageElement} image */
    #loadHover(image) {
      image.removeAttribute('data-fa-loaded');
      image.classList.remove('fa-hover-lifestyle');
      image.onload = () => {
        if (FaSwatchSwitch.#isLifestyle(image)) image.classList.add('fa-hover-lifestyle');
        image.setAttribute('data-fa-loaded', '');
      };
      image.src = image.dataset.src ?? '';
    }

    /**
     * Studio photos have the page colour baked into their background and melt into
     * the tile; a lifestyle photo has its own scene. Tell them apart by the corners.
     * @param {HTMLImageElement} image
     */
    static #isLifestyle(image) {
      try {
        const size = 24;
        const canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        const context = canvas.getContext('2d', { willReadFrequently: true });
        if (!context) return false;
        context.drawImage(image, 0, 0, size, size);
        const corners = [
          [1, 1],
          [size - 2, 1],
          [1, size - 2],
          [size - 2, size - 2],
        ];
        let away = 0;
        for (const [x, y] of corners) {
          const [r, g, b] = context.getImageData(x, y, 1, 1).data;
          // The page colour is #F4F1EC; studio backgrounds sit within a few steps of it
          const distance = Math.abs(r - 244) + Math.abs(g - 241) + Math.abs(b - 236);
          if (distance > 45) away++;
        }
        return away >= 2;
      } catch {
        return false;
      }
    }

    #onChange = (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'radio' || !input.dataset.url) return;
      // Nested switches (none today) handle their own swatches
      if (input.closest('fa-swatch-switch') !== this) return;

      const data = input.dataset;

      for (const idInput of this.querySelectorAll('input[name="id"]')) idInput.value = input.value;

      for (const image of this.querySelectorAll('img.fa-swatch-image')) {
        if (!data.image) continue;
        image.removeAttribute('srcset');
        image.src = data.image;
      }

      for (const link of this.querySelectorAll('[data-fa-link]')) {
        link.setAttribute('href', data.url);
        if (link.dataset.faLinkTitle) link.setAttribute('aria-label', `${link.dataset.faLinkTitle}, ${data.colour}`);
      }

      for (const price of this.querySelectorAll('[data-fa-price]')) this.#renderPrice(price, data);

      for (const line of this.querySelectorAll('[data-fa-per-piece]')) line.textContent = data.perPiece ?? '';

      // The hover photo follows the chosen finish; it loads on the next hover, or now if already in use
      for (const image of this.querySelectorAll('img[data-fa-hover-image]')) {
        image.dataset.src = data.hoverImage ?? '';
        if (!image.getAttribute('src')) continue;
        if (data.hoverImage) {
          this.#loadHover(image);
        } else {
          image.removeAttribute('src');
          image.removeAttribute('data-fa-loaded');
        }
      }

      for (const button of this.querySelectorAll('[ref="addToCartButton"]')) {
        button.disabled = input.disabled;
        if (button.dataset.faTitle) button.setAttribute('aria-label', `Add ${button.dataset.faTitle}, ${data.colour} to cart`);
        const container = button.closest('add-to-cart-component');
        if (container instanceof HTMLElement && data.image) container.dataset.productVariantMedia = data.image;
      }
    };

    /**
     * @param {HTMLElement} target
     * @param {DOMStringMap} data
     */
    #renderPrice(target, data) {
      const regularLabel = this.dataset.regularLabel ?? '';
      const parts = [];

      if (target.dataset.faPrice === 'row') {
        parts.push(document.createTextNode(data.price ?? ''));
      } else {
        const price = document.createElement('span');
        price.className = 'price';
        price.textContent = data.price ?? '';
        parts.push(price);
      }

      if (data.compare) {
        const compare = document.createElement(target.dataset.faPrice === 'row' ? 's' : 'span');
        if (target.dataset.faPrice !== 'row') compare.className = 'compare-at-price';
        const hidden = document.createElement('span');
        hidden.className = 'visually-hidden';
        hidden.textContent = regularLabel;
        compare.append(hidden, data.compare);
        // Cards: the crossed-out price comes first; cart rows keep it after the price
        if (target.dataset.faPrice === 'row') parts.push(document.createTextNode(' '), compare);
        else parts.unshift(compare, document.createTextNode(' '));
      }

      if (target.dataset.faPrice === 'row' && data.colour) {
        const colour = document.createElement('span');
        colour.className = 'fa-cart-upsell__variant';
        colour.textContent = `· ${data.colour}`;
        parts.push(document.createTextNode(' '), colour);
      }

      target.replaceChildren(...parts);
    }
  }

  if (!customElements.get('fa-swatch-switch')) customElements.define('fa-swatch-switch', FaSwatchSwitch);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fa-threshold"] && !Shopify.designMode) return;
  try {
    /*
    Far & Away: amounts in the shopper's currency for markets the "by currency" lists
    in Theme settings do not cover. The page shows the store-currency amount first;
    here it becomes the converted amount, at Shopify's rate, formatted for the
    currency. Re-applies when the cart drawer's re-render puts the server text back.
  */
  (() => {
    if (window.faMoney) return;

    const active = () => window.Shopify?.currency?.active;

    // The amount in the shopper's currency (whole units), or null when there is no rate
    const resolve = (el) => {
      const currency = active();
      if (!currency) return null;
      let map = {};
      try {
        map = JSON.parse(el.dataset.map || '{}') || {};
      } catch {}
      if (typeof map[currency] === 'number') return map[currency];
      const base = Number(el.dataset.base);
      if (currency === el.dataset.shop) return base;
      const rate = parseFloat(window.Shopify?.currency?.rate);
      if (!(rate > 0) || !(base >= 0)) return null;
      return Math.round(base * rate * 100) / 100;
    };

    const format = (amount) => {
      const currency = active();
      const whole = Math.abs(amount % 1) < 0.005;
      const lang = document.documentElement.lang || 'en';
      const country = window.Shopify?.country;
      const locale = country ? `${lang}-${country}` : lang;
      const options = { style: 'currency', currency };
      if (whole) Object.assign(options, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      try {
        return new Intl.NumberFormat(locale, options).format(amount);
      } catch {
        return `${currency} ${whole ? Math.round(amount) : amount.toFixed(2)}`;
      }
    };

    const needed = (el) => !!active() && el.dataset.rendered !== active();

    class FaMoney extends HTMLElement {
      connectedCallback() {
        this.apply();
        if (!this.observer && needed(this)) {
          this.observer = new MutationObserver(() => this.apply());
          this.observer.observe(this, { childList: true, characterData: true, subtree: true, attributes: true });
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
      }

      apply() {
        if (!needed(this)) return;
        const amount = resolve(this);
        if (amount == null) return;
        const text = format(amount);
        if (this.textContent !== text) this.textContent = text;
      }
    }

    // The cart bar: the remaining amount and the progress, compared in the shopper's currency
    class FaShippingBar extends HTMLElement {
      connectedCallback() {
        this.apply();
        if (!this.observer && needed(this)) {
          this.observer = new MutationObserver(() => this.apply());
          this.observer.observe(this, { childList: true, characterData: true, subtree: true, attributes: true });
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
      }

      apply() {
        if (!needed(this)) return;
        const threshold = resolve(this);
        const away = this.querySelector('[data-fa-away]');
        const unlocked = this.querySelector('[data-fa-unlocked]');
        const amount = this.querySelector('.fa-cart-shipping__amount');
        const fill = this.querySelector('.fa-cart-shipping__fill');
        if (threshold == null || !(threshold > 0)) {
          if (!this.hidden) this.hidden = true;
          return;
        }
        const total = Number(this.dataset.total) / 100;
        const remaining = Math.max(0, Math.round((threshold - total) * 100) / 100);
        const progress = `${Math.min(100, Math.floor((total / threshold) * 100))}%`;
        const text = format(remaining);
        if (amount && amount.textContent !== text) amount.textContent = text;
        if (away && away.hidden !== !(remaining > 0)) away.hidden = !(remaining > 0);
        if (unlocked && unlocked.hidden !== remaining > 0) unlocked.hidden = remaining > 0;
        this.classList.toggle('fa-cart-shipping--unlocked', !(remaining > 0));
        if (fill && fill.style.getPropertyValue('--fa-progress') !== progress) fill.style.setProperty('--fa-progress', progress);
        if (this.hidden) this.hidden = false;
      }
    }

    if (!customElements.get('fa-money')) customElements.define('fa-money', FaMoney);
    if (!customElements.get('fa-shipping-bar')) customElements.define('fa-shipping-bar', FaShippingBar);

    window.faMoney = {
      format,
      // Re-applies every amount, e.g. after the page's currency details change
      refresh() {
        for (const el of document.querySelectorAll('fa-money, fa-shipping-bar')) el.connectedCallback();
      },
    };
  })();
  } catch(e) { console.error(e); }
})();

})();
